import { z } from 'zod';
import { env } from '@/shared/lib/env';

export const claimSchema = z.object({
  pinfl: z
    .string()
    .trim()
    .length(env.pinflLength, 'claim:errors.pinflLength')
    .regex(/^\d+$/u, 'claim:errors.pinflDigitsOnly'),
  // Owner spec (2026-05-31): 5–255 chars; uppercased on input upstream.
  trek_id: z
    .string()
    .trim()
    .min(5, 'claim:errors.trekIdMin')
    .max(255, 'claim:errors.tooLong')
    .regex(/^[A-Za-z0-9-]+$/u, 'claim:errors.trekIdInvalid'),
});

export type ClaimValues = z.infer<typeof claimSchema>;
